import colors from 'chalk'
import { treatSoftErrors, treatWarnings } from "./handlers"
import fileSize from 'filesize'
import { ensureLicense, ensureContributeFile, ensureCOC } from './meta-manager'
// import webpackMiddleware from 'webpack-dev-middleware'
import myIP from 'my-ip'
import path from 'path'
// import httpServer from './http-server'
// import { readFile } from './utils'
import { analyzeDependencies, getOutdated } from './module-verifier'
import { DEFAULT_DEV_SERVER_PORT } from './utils'
import fs from 'fs-extra'
// import { Spinner } from 'cli-spinner'
import * as tu from './terminal-utils'

var buildNumber = 0

/**
 * Executes the compilation from generated webpack configuration.
 * 
 * It will also start a spinner animation and starts the HTTP Servers
 * and will show the header and status line for each build.
 * 
 * @param {Object} err 
 * @param {Object} stats Webpack stats object
 */
export default async function buildRunner (err, stats) {

    if (global.isInstalling) {
        return
    }

    const lineSize = tu.getLineSize
    const lineTop = tu.getLineTop
    const lineBottom = tu.getLineBottom
    const spinner = this.spinner
    let reports = []

    // treating any error that may have happened before this point
    if (err) {
        // if there are no files to be processed, err is an empty object
        if (Object.keys(err).length) {
            // if there were errors, we end the program
            console.log(tu.errorMessage('Startup error:'))
            console.error(err.error ? err.error.message : err.message)
            spinner.stop()
            // process.exit(1)
            return
        }
    }
    
    // start a animation in terminal
    if (!spinner.isSpinning()) {
        spinner.start()
    }

    spinner.setSpinnerTitle('Building... ')
    // move cursor to begining of line in terminal
    tu.moveTo('lineStart')

    // if this is the first build (not in watch)
    // and the user has these reports enabled
    if (
        buildNumber === 0 &&
        (this.opts.reports.unusedDeps || this.opts.reports.outdatedDeps)) {
        
        // in the first build, we show the dependencies report
        let depsReport = await analyzeDependencies(
            this.paths.project,
            this.settings.webpackConfig
        )

        // Detecting unused modules and reporting them
        if (this.opts.reports.unusedDeps && depsReport.unused.length) {
            reports.push(
                tu.reportMessage(
                    'The following modules are installed but never used:' +
                    tu.list(depsReport.unused)
                )
            )
        }

        // verifying outdated modules and reporting them
        if (this.opts.reports.outdatedDeps) {
            // let's compare the outdated packages with their current version in the package.json
            let outdatedReport = await getOutdated(this.paths.project + '/package.json')

            if (outdatedReport.length) {
                reports.push(
                    tu.timingReport('You have outdated modules:' + tu.list(outdatedReport))
                )
            }
        }
    } else {
        reports = []
    }

    if (buildNumber === 0) {
        const pkg = this.pkg
        // this is asynchronouse, but we don't have to wait for it
        ensureLicense(this.paths, pkg)
        ensureContributeFile(this.paths, pkg)
        ensureCOC(this.paths, pkg)
    }

    // increase the build number
    buildNumber++

    const opts = this.opts
    // const initReports = this.initReports
    const jsonStats = stats ? stats.toJson() : { hash: '', stats: [], warnings: [], errors: [], children: [] }

    stats = stats || jsonStats
    let buildStatus = jsonStats.errors.length
        ? 'Has errors'
        : jsonStats.warnings.length
            ? 'Has warnings'
            : 'Ok'

    // treating errors, warnings and info messages
    const treatedErrors = await treatSoftErrors(stats, this, opts)
    const treatedErrorMessages = treatedErrors.messages
    const treatedWarns = treatWarnings(jsonStats.warnings, this.paths, opts)

    // the list of assets from this build
    let assets = jsonStats.children.length ? jsonStats.children.reduce((prev, cur) => {
        return prev ? prev.assets.concat(cur.assets) : cur.assets
    }) : []

    assets = assets.assets || []
    
    // used to the timestamp
    let dt = new Date()
    dt = dt.toTimeString().substr(0, 8) + dt.toTimeString().substr(-6)
    
    // used for the terminal decoration and output
    // let info = colors.bgBlue.white
    let header = ''
    let str = ''
    let upAt = ''
    let isDebugging = opts.mode === 'dev' && opts.debug

    // Retrieves the http address for the server
    // if it is enabled in options
    // if (opts.server && opts.server.port) {
    opts.server = opts.server || {}
    upAt = `http://${myIP()}:${opts.server.port || DEFAULT_DEV_SERVER_PORT}/`
    // }

    // preparing the header to be used in terminal for the build
    let headerLines = [
        // build number
        `${colors.bold('Build: ')} #${buildNumber.toString().padEnd(lineSize() - 24, ' ')}`+
        `PID: ${process.pid.toString().padStart(8, ' ')}`,
        // hash and timestamp
        colors.bold('Hash: ') + (stats.hash || 'empty build').padEnd(40, ' ') + dt.padStart(lineSize() - 48, ' ') + ' ',
        // status and http address
        (colors.bold('Status: ') + buildStatus)
            .padEnd(lineSize() + 7 - upAt.length, ' ') +
            colors.bold.underline(upAt) + '   ',
        // mode (development or production)
        (
            colors.bold('Mode: ') + opts.mode +
            (isDebugging ? ' (debugging)' : '')
        ).padEnd(lineSize() + 9, ' ') + ' '
    ]
    // adding the timing for each target build into the header
    if (stats.stats.length) {
        headerLines.push(colors.bold('Times: ').padEnd(40, ' '))// + ('PID: ' + process.pid).padStart(lineSize() - 35, ' ') + ' ')
        stats.stats.forEach(stat => {
            let str = colors.bold(stat.compilation.options.target) + ': ' + (stat.endTime - stat.startTime) + 'ms'
            headerLines.push('  ' + str)
        })
    }
    
    // headerLines.push('  ' + stats.httpServerService ? stats.httpServerService.pid : 'XXXXXXX')

    // Decorate the header
    header = tu.headerMessage(headerLines)
    str+= header;
    
    // time to treat the assets before listing them
    if (!Array.isArray(assets)) {
        assets = [assets]
    }
    
    let hasEmitted = false
    let mapFiles = 0
    let iconFiles = 0
    let gzFiles = 0
    let extraFiles = 0

    // let's hide some kinds of assets
    // and highlight the ones with warnings
    assets.forEach((asset, i) => {
        if (asset.emitted) {
            if (asset.name.match(/(public|vendors|hot|assets|docs)\//)) {
                extraFiles++
                return
            }

            hasEmitted = true
            if (i === 0) {
                str+= '\n'
            }
            if (asset.name.startsWith('icons/')) {
                iconFiles++
            } else if (asset.name.endsWith('.map')) {
                mapFiles++
            } else if (asset.name.endsWith('.gz')) {
                gzFiles++
            } else {
                let tmpStr = tu.item(asset.name, fileSize(asset.size, {symbols: {B: " B"}}))
                if (asset.isOverSizeLimit) {
                    tmpStr = colors.bold.yellow(tmpStr)
                }
                str+= tmpStr
            }
        }
    })
    
    // we don't show the list of source maps, instead we show its counter
    if (mapFiles) {
        str+= tu.listItem(`${mapFiles} source maps`, '+')
    }
    // same thing for the gziped files
    if (gzFiles) {
        str+= tu.listItem(`${gzFiles} Gziped files`, '+')
    }
    // and also icons
    if (iconFiles) {
        str+= tu.listItem(`${iconFiles} Icon files`, '+')
    }
    // and extra files (like copied vendors/public files or hot/)
    if (iconFiles) {
        str+= tu.listItem(`${iconFiles} Hiden files`, '+')
    }
    if (hasEmitted) {
        if (extraFiles) {
            str+= tu.listItem(`${extraFiles} Hiden files`, '+')
        }
        str+= lineBottom()
    }

    // let's show the notes/errors
    let status = 1
    let messages = ''
    let errorsLen = jsonStats.errors.length
    if (jsonStats.warnings.length) {
        // separating the warning messages from the info ones
        status = 2
        messages+= tu.join(treatedWarns.warns, true)
        messages+= tu.join(treatedWarns.infos, true)
    }
    
    // add a better treatment for the error messages
    if (treatedErrorMessages.length) {
        status = 3
        if (!treatedErrorMessages.length) {
            // something went wrong managing errors!
            if (jsonStats.errors.length) {
                messages += tu.join(jsonStats.errors, true)
            }
        } else {
            if (treatedErrorMessages.length) {
                messages += tu.join(treatedErrorMessages, true)
            }
        }
    }

    // adding the reports to the list of messages
    if (reports.length) {
        messages+= tu.join(reports, true)
    }

    // and now add the messages to the output
    str+= messages.length
        ? tu.title('NOTES:') + messages + '\n' + lineBottom()
        : ''
    
    // setting up the status line
    // as the footer for the building output
    let statusLeft = `Build #${buildNumber}`.padEnd(16, ' ') + ' at ' + dt
    let statusRight = status === 1
        ? `✔`.padStart(12, ' ')
        : `${treatedWarns.warns.length} (!) ${errorsLen} (✖)`

    // add the status line to the output string
    str += tu.statusLine(
        status,
        statusLeft.padEnd(lineSize() - 13, ' ') +
        statusRight.padStart(13, ' '))

    if (errorsLen) {
        // try to produce a sound when there are errors in terminal
        // some terminals (or global configuration) may not allow
        // the sound, though
        tu.beep()
    }

    // end of loading
    spinner.stop(true)
    console.log(str + '\n' + lineTop())    
}



// WEBPACK FOOTER //
// ./src/build-runner.js